import React from "react";

import { ProductDetailPage } from "../../components/product-detail/ProductDetailPage";
const Pass: React.FC = () => <ProductDetailPage />;

export default Pass;
